import React from "react";
import { ArrowUpRight, Phone, Mail, Instagram } from "lucide-react";

export default function Footer() {
    return (
        <footer
            className="relative py-16 md:py-20 bg-[#050505]"
            data-testid="site-footer"
        >
            <div className="max-w-[1600px] mx-auto px-6 md:px-10">
                <div className="border-t border-white/10 pt-16">
                    <div className="flex items-start justify-between gap-8 mb-12 flex-wrap">
                        <div className="flex items-center gap-3">
                            <img
                                src="/mascot.png"
                                alt="GreenDuck"
                                className="w-14 h-14 object-contain drop-shadow-[0_0_20px_rgba(0,255,102,0.4)]"
                            />
                            <div>
                                <div
                                    className="text-white text-2xl font-extrabold tracking-tight"
                                    style={{
                                        fontFamily:
                                            '"Clash Display", "Unbounded", sans-serif',
                                        letterSpacing: "-0.03em",
                                    }}
                                >
                                    Green<span className="text-[#00FF66]">Duck</span>
                                </div>
                                <div className="mt-1 font-mono-tech text-xs text-white/40 uppercase tracking-widest">
                                    Estúdio de tecnologia
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="font-display uppercase text-[16vw] md:text-[13vw] leading-[0.85] tracking-tighter text-white/[0.05] mb-12 pointer-events-none select-none">
                        GreenDuck.
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-16">
                        <div>
                            <div className="font-mono-tech text-xs uppercase tracking-widest text-white/40 mb-4">
                                Contato
                            </div>
                            <ul className="space-y-3 text-white/70 text-sm">
                                <li>
                                    <a
                                        href="mailto:contatogreenduck@gmail.com"
                                        className="inline-flex items-center gap-2 hover:text-[#00FF66] transition-colors"
                                        data-testid="footer-email"
                                    >
                                        <Mail className="w-4 h-4" strokeWidth={1.5} />
                                        contatogreenduck@gmail.com
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="tel:+558581220308"
                                        className="inline-flex items-center gap-2 hover:text-[#00FF66] transition-colors"
                                        data-testid="footer-phone"
                                    >
                                        <Phone className="w-4 h-4" strokeWidth={1.5} />
                                        +55 85 8122-0308
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <div className="font-mono-tech text-xs uppercase tracking-widest text-white/40 mb-4">
                                Navegar
                            </div>
                            <ul className="space-y-2 text-white/70 text-sm">
                                <li>
                                    <a href="/#servicos" className="hover:text-[#00FF66] transition-colors">
                                        Serviços
                                    </a>
                                </li>
                                <li>
                                    <a href="/#trabalhos" className="hover:text-[#00FF66] transition-colors">
                                        Trabalhos
                                    </a>
                                </li>
                                <li>
                                    <a href="/#processo" className="hover:text-[#00FF66] transition-colors">
                                        Processo
                                    </a>
                                </li>
                                <li>
                                    <a href="/#contato" className="hover:text-[#00FF66] transition-colors">
                                        Contato
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <div className="font-mono-tech text-xs uppercase tracking-widest text-white/40 mb-4">
                                Social
                            </div>
                            <ul className="space-y-2 text-white/70 text-sm">
                                <li>
                                    <a
                                        href="https://instagram.com/greenduckoficial"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="inline-flex items-center gap-2 hover:text-[#00FF66] transition-colors"
                                        data-testid="footer-instagram"
                                    >
                                        <Instagram className="w-4 h-4" strokeWidth={1.5} />
                                        @greenduckoficial
                                        <ArrowUpRight className="w-3 h-3" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="border-t border-white/10 pt-6 flex flex-wrap items-center justify-between gap-4">
                        <div className="font-mono-tech text-xs text-white/40 uppercase tracking-widest">
                            © {new Date().getFullYear()} GreenDuck · Todos os
                            direitos reservados
                        </div>
                        <a
                            href="/admin/login"
                            className="font-mono-tech text-xs text-white/40 hover:text-[#00FF66] uppercase tracking-widest"
                            data-testid="footer-admin-link"
                        >
                            Área do administrador →
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
